export const transformChecklist = (data) => {
  const {
    name,
    ...rest
  } = data;

  return {
    ...rest,
    title: name,
  };
};

export const transformGqlDataToRecord = (data) => {
  const {
    id,
    orgId,
    status,
    dateInquiry,
    // contactName,
    contactFirstName,
    contactLastName,
    // profileImage,
    // contactEmail,
    // contactNumber,
    contactId,
    eventDate,
    // eventLocation,
    startTime,
    endTime,
    allDay,
    // serviceType,
    // leadSource,
    estimateBudget,
    // estimateBudgetFormatted,
    lastContactedDate,
    leadCustomStatusId,
    lostReasonId,
    contactCompanyName,
    orgLeadContactId,
    isDeleted,
    // organizationMemberAssignments,
    party,
    projectName,
    venueName,
    createdAt,
  } = data;

  return {
    lead: {
      id,
      organizationId: orgId,
      weddingId: null,
      discussionId: null,
      leadCustomStatusId,
      status,
      lostReason: lostReasonId,
      role: null,
      dateInquiry,
      venueName,
      contactFirstName,
      contactLastName,
      contactCompanyName,
      contactId,
      party,
      weddingDate: eventDate,
      addressId: null,
      locationId: null,
      timezone: null,
      estimatedGuestCount: 0,
      estimatedBudget: estimateBudget,
      projectName,
      projectType: null,
      notes: '',
      createdAt,
      createdById: null,
      updatedAt: null,
      updatedById: null,
      leadSourceId: null,
      serviceTypeId: null,
      reasonForNotBookingId: null,
      lastContactedDate,
      isLeadIntake: null,
      isFromListing: null,
      isDeleted,
      organizationLeadContactId: orgLeadContactId,
      isSavedLead: true,
      allDay,
      startTime,
      endTime,
      customStatus: {
        id: leadCustomStatusId,
        orgId,
      },
    },
  };
};
